// extracted by mini-css-extract-plugin
module.exports = {"title":"SectionHeading_title__4L83E"};